import React, { Component } from 'react';
import JobsTable from '../jobs/jobs-table.jsx';
import moment from 'moment';
import TooManyRequestExceptions from '../../Exceptions/TooManyRequestExceptions.js';
export default class Driver extends Component {
  constructor(props) {
    super(props);
    let url = "/api/v1/portal/jobs/driver/" +
        props.data.driver.id +
        (props.viewAllJobs ? "/all-jobs" : "");

    this.state = {
      text: props.initialValue || 'placeholder',
      data: props.data || {
        driver: null
      },
      notes:props.data.driver.notes,
      additionalNotes:props.data.driver.additionalNotes,
      isLoading: true,
      viewAllJobs: props.viewAllJobs || null,
      jobs: props.jobs || null,
      url: url || null,
      jobIds:[],
      driverDailyEarnings : props.driverDailyEarnings || '0.00',
      driverDailyEarningButtonColor : props.driverDailyEarningButtonColor,
      driverWeeklyEarnings : props.driverWeeklyEarnings || '0.00',
      driverWeeklyEarningButtonColor : props.driverWeeklyEarningButtonColor,
      infiniteScroll: props.infiniteScroll || false,
      currentTime : '',
      isDriverDashboardPage: props.isDriverDashboardPage || false,
    };
    this.changePleoStatus = this.changePleoStatus.bind(this);
    this.handleAdditionalNoteChange = this.handleAdditionalNoteChange.bind(this);
    this.handleAdditionalNotesKeyDown = this.handleAdditionalNotesKeyDown.bind(this);

    Echo.channel('driver-scheduled-list-update-'+ this.props.data.driver.id).listen('DriverScheduledListUpdate', (e) => {
      if (e.driver && e.driver.id == this.props.data.driver.id) {
        this.setState({
          driver: e.driver
        });
      }

      if(e.driverId){
        if(e.driverId == this.props.data.driver.id){
          this.getDriverJobs();
          $('#driver-table-list-'+e.driverId +' .late-driver-alert ').removeClass('late-driver-alert');
        }
      }else{
        if(this.state.jobs && this.state.jobs.length > 0){
          let Updateindex = this.state.jobs.findIndex(job => job.id == e.jobId);
          if(Updateindex != -1){
            this.state.jobs.splice(Updateindex, 1);
            this.setState({jobs:this.state.jobs});
          }
        }
      }
    });
  }

  handleAdditionalNoteChange(event) {
    this.state.data.driver.additionalNotes =  event.target.value
    this.setState({data: this.state.data});
  }

  handleAdditionalNotesKeyDown(event) {
    if (event.key === 'Enter') {
      $.ajax({
        url: "/api/v1/portal/jobs/change-driver-notes/"+this.state.data.driver.id,
        data: {
          api_token: window.api_token,
          additionalNotes: this.state.data.driver.additionalNotes
        },
        cache: false,
        method: 'post',
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({
        data: nextProps.data
      });
    }
  }

  getDriverJobs(){
    return fetch(
      `${this.state.url}?is_driver_dashboardpage=${encodeURIComponent(this.state.isDriverDashboardPage)}`,
      {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
      }
    ).then((responseText) => {
      if(responseText.status==429) {
        throw new TooManyRequestExceptions('drivers/dashboard ⚠️');
      }
      return responseText.json();
    }).then((driverJson) => {
      if(!this.props.viewAllJobs){
        this.setState({ data: { ...this.state.data, driver: driverJson.driver } });
      }
      this.setState({
        jobs: driverJson.data,
        driverDailyEarnings : driverJson.driverDailyEarnings,
        driverDailyEarningButtonColor : driverJson.driverDailyEarningButtonColor,
        driverWeeklyEarnings : driverJson.driverWeeklyEarnings,
        driverWeeklyEarningButtonColor : driverJson.driverWeeklyEarningButtonColor,
        isLoading: false,
        currentTime : driverJson.currentTime,
      });
      let jobIds = [];
      // let overdueJobs= [];
      // let overdueJobsIn24hours= [];
      if(this.state.jobs){
        this.state.jobs.forEach((job) => {
          const jobId = job.id;
          jobIds.push(jobId);
          // if(this.state.isDriverDashboardPage){
          //   overdueJobs.push(jobId);

          //   if (moment(job.scheduled_dropoff_date).isSame(moment().format('Y-M-D'))) {
          //     overdueJobsIn24hours.push(jobId);
          //   }
          // }
        });
      }
      this.setState({jobIds:jobIds});
      if(this.state.isDriverDashboardPage){
        // this.props.handleDriverStatestics(overdueJobs,overdueJobsIn24hours,this.state.data.id);
        this.props.handleRerenderTrigger(this.state.jobs, this.state.data.id, this.state.data.driver);
      }
    })
    .catch((error) => {
      if (error instanceof TooManyRequestExceptions) {
        if (window.bugsnagClient) {
          window.bugsnagClient.notify(error);
        } else {
          console.error("Bugsnag is not initialized", error);
        }
      }
    });
  }
  componentDidMount() {
    if (this.state.isLoading) {
      this.getDriverJobs();
    }
  }
  componentDidUpdate() {
    let pickupTime = ['?','anytime','am','asap','pm'];
    let scheduledPickupTime = '';
    let scheduledPickupDate = '';
    let msg = null;
    if(this.state.jobs && this.state.jobs.length > 0){
      let tempJob = this.state.jobs[0];
      
      if(pickupTime.indexOf(tempJob.scheduled_pickup_time) != -1){
        scheduledPickupTime = '0805';
        scheduledPickupDate = tempJob.scheduled_pickup_year+'-'+tempJob.scheduled_pickup_month+'-'+tempJob.scheduled_pickup_day;
      }else{
        scheduledPickupTime = tempJob.scheduled_pickup_time;
        scheduledPickupDate = tempJob.scheduled_pickup_year+'-'+tempJob.scheduled_pickup_month+'-'+tempJob.scheduled_pickup_day;
      }
      /* check if appraisal is not set yet */
      if(tempJob.appraisal_id == null){
        let currentDate = moment().format('YYYY-MM-DD'); 
        const scheduledPickupTimeAddedBy30Mins = moment(scheduledPickupTime, "HHmm").add(30, 'minutes').format('HHmm');
        const currentTime = moment(this.state.currentTime).format("HHmm");
        if( (moment(currentDate).isSame(scheduledPickupDate)) && (scheduledPickupTimeAddedBy30Mins < currentTime)){
              msg = '<div><b>'+this.state.data.full_name+' </b> is more then 30mins late for this job : '+"<a target='_blank' href='/jobs/view/"+tempJob.id+"'> #"+tempJob.id+"</a> ("+this.state.data.driver.contact_number+')</div>';
              $('#jobs-table-row-'+tempJob.id).addClass('late-driver-alert');
              this.props.saveLateJobIdsOFDriver(tempJob.id);
            }
        }
      }
    this.props.handleLateDrivers(msg,this.state.data.id);
  }
  changeJobPrice(e) {
    let driverNotes = this.state.data.driver.notes;
    let holidayNotes = this.state.data.driver.holiday_notes;
      $.ajax({
        url: "/api/v1/portal/jobs/change-driver-notes/"+this.state.data.driver.id,
        data: {
          api_token: window.api_token,
          driver_notes: driverNotes,
          holiday_notes: holidayNotes
        },
        cache: false,
        method: 'post',
      })
      .done(function() {
        // 
      }).
      catch(function(e) {
        alert(e);
      });
  }
  enterPressed(event) {
    let code = event.keyCode || event.which;
    if (code === 13) { // [ Enter ]
      $(event.target).trigger('blur');
    }
  }
  handleDriverNotesChange(event){
    this.state.data.driver.notes =  event.target.value
    this.setState({data: this.state.data});
  }
  handleDriverHolidayNotesChange(event){
    this.state.data.driver.holiday_notes =  event.target.value
    this.setState({data: this.state.data});
  }
  changePleoStatus(e,status){
    e.preventDefault();
    let url = "/api/v1/portal/jobs/change-driver-pleo-status/"+this.state.data.driver.id;
    const data = {'pleo_status':status};
    fetch(url, {
      method: "PUT",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token,
        "Accept": 'application/json',
        'Content-Type': 'application/json'
      },
      body:JSON.stringify(data),
    }).
    then((responseText) => {
      return responseText.json();
    }).then((response) => {
      this.setState({data : {...this.state.data,driver:response}});
    });
    return false;
  }
  render() {
    let schedulePanelColor = '';
    if(this.state.data.is_driver_one_job)
    {
      schedulePanelColor = 'schedule_panel_purple';
    }
    if(this.state.data.is_driver_new)
    {
      schedulePanelColor = 'schedule_panel_blue';
    }
    if(this.state.data.is_driver_sick)
    {
      schedulePanelColor = 'schedule_panel_green';
    }
    if(this.state.data.is_driver_do_not_pay)
    {
      schedulePanelColor = 'schedule_panel_red';
    }
    
    let did = "driver-table-list-"+this.state.data.driver.id;
    let infiniteScroll = this.state.infiniteScroll;

    let lastJobOfDriver;
    let dashboardPanelColor = 'bg-pink';
    //you can change currentDay to simulate code for saturday and sunday!
    //i.e. moment("2023-10-13 00:00:00")
    const currentDay = moment();
    let fifthAndMoreDay = moment(currentDay).clone().add(4,'day');
    let forthDay = moment(currentDay).clone().add(3,'day');
    let dayAfterTommorow = moment(currentDay).clone().add(2,'day');
    let tommorow = moment(currentDay).clone().add(1,'day');
    let today = moment(currentDay).clone();
   
    //skip saturday and sunday for day hth day.
    while (fifthAndMoreDay.day() === 0 || fifthAndMoreDay.day() === 6) {
      fifthAndMoreDay = fifthAndMoreDay.add(2, "day");
    }
    //skip saturday and sunday for 4th day.
    while (forthDay.day() === 0 || forthDay.day() === 6) {
      forthDay = forthDay.add(2, "day");
    }
    //skip saturday and sunday for day after tommorow.
    while (dayAfterTommorow.day() === 0 || dayAfterTommorow.day() === 6) {
      dayAfterTommorow = dayAfterTommorow.add(2, "day");
    }
    //skip saturday and sunday for tommorow.
    while (tommorow.day() === 0 || tommorow.day() === 6) {
      tommorow = tommorow.add(2, "day");
    }

    if(this.state.isDriverDashboardPage && this.state.jobs){
      lastJobOfDriver = _.last(this.state.jobs);
      if(!lastJobOfDriver){
        // not job available.
        dashboardPanelColor = 'bg-primary';
      } else {
        const scheduled_dropoff_date = moment(lastJobOfDriver.scheduled_dropoff_date,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
       
        if(moment(scheduled_dropoff_date).isSameOrAfter(fifthAndMoreDay.format('YYYY-MM-DD'))){
          //day afer 96 hrs, yello color
          dashboardPanelColor = 'bg-yellow';
        }
        if(moment(scheduled_dropoff_date).isSame(forthDay.format('YYYY-MM-DD'))){
          //day afer 72 hrs, cyan color
          dashboardPanelColor = 'bg-cyan';
        }
        if(moment(scheduled_dropoff_date).isSame(dayAfterTommorow.format('YYYY-MM-DD'))){
          //day afer tommorow, green color
          dashboardPanelColor = 'bg-success';
        }
        if(moment(scheduled_dropoff_date).isSame(tommorow.format('YYYY-MM-DD'))){
          //next day, orange color
          dashboardPanelColor = 'bg-orange';
        }
        if(moment(scheduled_dropoff_date).isSame(today.format('YYYY-MM-DD'))){
          //same day, red color.
          dashboardPanelColor = 'bg-danger';
        }
      }
      if(this.state.data.is_driver_sick){
        //driver is not active or sick
        dashboardPanelColor += ' text-decoration-line-through';
      }

    }

    return(
    <div className="driver-table" id={did}>
      {
        this.state.isLoading ?
        <div className="loading-box">
          <span className="add-loading-text">
            <i className="fas fa-spinner fa-pulse"></i>
          </span>
        </div> :
          
          ((  this.state.data &&
              this.state.data.driver &&
              this.state.data.driver.contact_number &&
              !this.state.isDriverDashboardPage
            ) ?

              <div className="driver-container">
                <div className={"driver-main-info "+schedulePanelColor+""}>
                  <div className="row">
                    {/* <div className="col-md-1"> */}
                      {/* <img
                        src={"/user-images/" + this.state.data.id}
                        className="drivers-table-main-info-user-image"
                      /> */}
                    {/* </div> */}
                    <div className="col-md-3">
                      <img
                        src={"/user-images/" + this.state.data.id}
                        className="drivers-table-main-info-user-image"
                      />&nbsp;&nbsp;&nbsp;
                      {/* <strong>Driver Name:</strong>  */}
                      {
                      this.state.data.first_name} {
                      this.state.data.last_name}&nbsp;&nbsp;
                      <a
                        href={"/drivers/view/" + this.state.data.id +
                        "/all-jobs"}
                        className="btn btn-sm btn-primary"
                      >
                        <i className="fa fa-car-side"></i> All Jobs
                      </a>
                      {/* Driver Daily Earning */}
                      <button type="button"
                        className={this.state.driverDailyEarningButtonColor}
                        data-toggle="tooltip" data-placement="right" data-original-title={this.state.driverDailyEarnings}
                      >
                        {this.state.driverDailyEarnings}
                      </button>
                      {/* Driver Weekly Earning */}
                      <button type="button"
                        className={this.state.driverWeeklyEarningButtonColor}
                        data-toggle="tooltip" data-placement="right" data-original-title={this.state.driverWeeklyEarnings}
                      >
                        {this.state.driverWeeklyEarnings}
                      </button>
                      {/* <input type="text" className="float-right"
                          value={this.state.data.driver.holiday_notes ?? ''}
                          placeholder="- Add Holiday Notes -"
                          onChange={(e)=>this.handleDriverHolidayNotesChange(e)}
                          name="holiday_notes" /> */}
                    </div>
                    <div className="col-md-2 filter-date-section" style={{display: "inherit"}}>
                        {/* <textarea className="form-control form-control-lg"
                          name="driver_notes"
                          id="driver_notes"
                          placeholder="Add Notes"
                          defaultValue={this.state.data.driver.notes}
                          onChange={(e)=>this.handleDriverNotesChange(e)}>
                        </textarea> */}
                        <input type="text" className="jobs-table-editable form-control form-control-lg driver-notes-textbox"
                          value={this.state.data.driver.notes ?? ''}
                          placeholder="- Add Notes - "
                          onChange={(e)=>this.handleDriverNotesChange(e)}
                          name="notes" />&nbsp;&nbsp;
                          <a title="update driver notes & holiday notes" 
                             onClick={this.changeJobPrice.bind(this)}>
                               <i className="fa fa-lg fa-sync"></i>
                          </a>&nbsp;
                          {this.state.data.driver?.can_drive_type_d1 === 1 && (
                            <div >
                              <img
                                src={"/images/d1.png"}
                                className="d1-vehical-icon pl-2"
                                title="Can drive D1 category vehicle"
                                alt="Can drive D1 category vehicle"
                                style={{ width : '40px' }}
                              />
                            </div>
                          )}
                    </div>
                    <div className="col-md-4">
                      <a className="text-reset" href={'tel:'+this.state.data.driver.contact_number}><i className="fa fa-phone"></i> {this.state.data.driver.contact_number} </a>
                      <a className="text-reset" href={'mailTo:'+this.state.data.email+'?subject=driver/schedule&body=are you there?'}><i className="fa fa-envelope ml-3"></i>&nbsp; </a>
                      <strong className="ml-3">&nbsp;Pleo.</strong>
                      <div className="btn-group btn-group-toggle" id="inline-Pleo-btn" data-toggle="buttons">
                        <label onClick={(e) => this.changePleoStatus(e,true)} className={"btn btn-secondary mt-0 " +(this.state.data.driver.pleo_status ? ' active ' : '')} id="yes-manual-appraisal-required">
                          <input className={"form-control form-control-lg"+ (this.state.data.driver.pleo_status ? ' active ' : '')}
                            defaultChecked={(
                              this.state.data.driver.pleo_status
                            )}
                            name="manual_appraisal_required"
                            readOnly
                            type="radio"
                            value="1"
                            required /> On
                        </label>
                        <label onClick={(e) => this.changePleoStatus(e,false)} className={"btn btn-secondary mt-0 "+ (!this.state.data.driver.pleo_status ? ' active ' : '')} id="no-manual-appraisal-required">
                          <input className={"form-control form-control-lg"+ (!this.state.data.driver.pleo_status ? ' active ' : '')}
                            defaultChecked={(
                              !this.state.data.driver.pleo_status
                            )}
                            name="manual_appraisal_required"
                            type="radio"
                            value="0"
                            readOnly
                            required /> Off
                        </label>
                      </div>
                      <DriverColdStart id={this.state.data.driver.id} selectedOption={this.state.data.driver.cold_start_status}/>
                    </div>
                    {/* <div className="col-md-2">
                      <strong>Trade Plate:</strong>&nbsp;
                      <i className="fa fa-phone"></i> {
                      this.state.data.driver.contact_number}
                    </div>
                    <div className="col-md-2">
                        <i className="fa fa-envelope"></i>&nbsp; {
                        this.state.data.email}
                      </div> */}
                      { (this.state.data.driver.home_address) ? 
                      <div className="col-md-3">
                        <i className="fa fa-home"></i> {
                        this.state.data.driver.home_address.town_city} {
                        this.state.data.driver.home_address.county_area}&nbsp;&nbsp; | &nbsp;&nbsp;
                        <strong className="pFixed">Active/Working:&nbsp;&nbsp;
                          <button className="btn btn-primary buttonActiveWorking">
                            <b>{(this.state.data.driver.active_status) ? 'YES' : 'NO'}</b>
                          </button>
                        </strong>
                        
                      </div>
                      : ''
                      }
                  </div>
                </div>
                <div className={"row noteRow-"+this.state.data.driver.id}>
                    <div className="col-md-12">
                      <input type="text" className="form-control form-control-lg" 
                      placeholder="- Add Notes - " 
                      name="additionalNotes" 
                      value={this.state.data.driver.additionalNotes ?? ''}
                      onChange={this.handleAdditionalNoteChange}
                      onKeyDown={this.handleAdditionalNotesKeyDown}
                      />
                    </div>
                </div>
                <JobsTable
                  url={this.state.url}
                  jobs={this.state.jobs}
                  noCategoryLabels={true}
                  infiniteScroll={infiniteScroll}
                  message_if_none='No Jobs found. Add one to see it here.'
                  driverScreen={(this.state.url.search('all-jobs') > -1) ? false : true}
                  jobIds={this.state.jobIds}
                />
              </div>
              : ((this.state.data &&
                this.state.data.driver &&
                this.state.data.driver.contact_number &&
                this.state.isDriverDashboardPage
                ) ?
                    
              <div className="driver-container mb-0">
                 
                  <div className={"driver-main-info "+dashboardPanelColor+""}>
                  <div className="row">
                    <div className="col-md-3">
                      <p>{this.state.data.first_name} {this.state.data.last_name} &nbsp;&nbsp; </p>
                    </div>
                    <div className="col-md-3" title= {_.get(lastJobOfDriver ,'id') + "," +_.get(lastJobOfDriver ,'scheduled_dropoff_date')}>
                       <p> {_.get(lastJobOfDriver,'drop_day')} {this.state.data.driver.cold_start_status} </p>
                    </div>
                    <div className="col-md-3">
                      <p>{_.get(lastJobOfDriver ,'dropoff_address.town_city')}</p>
                    </div>
                    { (this.state.data.driver.home_address) ? 
                      <div className="col-md-3">
                        <p><i className="fa fa-home"></i> {this.state.data.driver.home_address.town_city} </p>
                      </div>
                      : ''
                      }
                    </div>
                </div>
              </div>
              : null))
        }
      </div>
    );
  }
}

export class DriverColdStart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.id || 0,
      selectedOption: props.selectedOption || null,
    }
    this.handleRadioChange = this.handleRadioChange.bind(this);
  }

  handleRadioChange(event){

    this.setState({
      selectedOption: event.target.value,
    });
    this.changeColdStartStatus(event.target.value);
  };

  changeColdStartStatus(ColdStartStatus) {
      $.ajax({
        url: "/api/v1/portal/driver/change-cold_start_status/"+this.state.id,
        data: {
          api_token: window.api_token,
          cold_start_status: ColdStartStatus,
        },
        cache: false,
        method: 'post',
      })
      .done(function() {
        // 
      }).
      catch(function(e) {
        alert(e);
      });
  }

  render() {
    const { id,selectedOption } = this.state;
    return (
      <div className="btn-group btn-group-toggle ml-3 driver-cold-start" data-toggle="buttons">
        <label className="btn btn-outline-primary mt-0" title="COLD START MON" htmlFor={"btnradio1" + id}>
          <input type="radio" className="btn-check" defaultChecked={selectedOption === 'COLD START MON'} name="cold_start_status" onClick={(e) => this.handleRadioChange(e)} value="COLD START MON" id={"btnradio1" + id} autoComplete="off" /> M
        </label>
        <label className="btn btn-outline-primary mt-0" title="COLD START TUES" htmlFor={"btnradio2" + id}>
          <input type="radio" className="btn-check" defaultChecked={selectedOption === 'COLD START TUES'} name="cold_start_status" onClick={(e) => this.handleRadioChange(e)} value="COLD START TUES" id={"btnradio2" + id} autoComplete="off" />T
        </label>
        <label className="btn btn-outline-primary mt-0" title="COLD START WEDS" htmlFor={"btnradio3" + id}>
          <input type="radio" className="btn-check" defaultChecked={selectedOption === 'COLD START WEDS'} name="cold_start_status" onClick={(e) => this.handleRadioChange(e)} value="COLD START WEDS" id={"btnradio3" + id} autoComplete="off" />W
        </label>
        <label className="btn btn-outline-primary mt-0" title="COLD START THURS" htmlFor={"btnradio4" + id}>
          <input type="radio" className="btn-check" defaultChecked={selectedOption === 'COLD START THURS'} name="cold_start_status" onClick={(e) => this.handleRadioChange(e)} value="COLD START THURS" id={"btnradio4" + id} autoComplete="off" />T
        </label>
        <label className="btn btn-outline-primary mt-0" title="COLD START FRI" htmlFor={"btnradio5" + id}>
          <input type="radio" className="btn-check" defaultChecked={selectedOption === 'COLD START FRI'} name="cold_start_status" onClick={(e) => this.handleRadioChange(e)} value="COLD START FRI" id={"btnradio5" + id} autoComplete="off" />F
        </label>
        <label className="btn btn-outline-primary mt-0" title="HOLIDAY" htmlFor={"btnradio6" + id}>
          <input type="radio" className="btn-check" defaultChecked={selectedOption === 'HOLIDAY'} name="cold_start_status" onClick={(e) => this.handleRadioChange(e)} value="HOLIDAY" id={"btnradio6" + id} autoComplete="off" />H
        </label>
        <label className="btn btn-outline-primary mt-0" title="SICK" htmlFor={"btnradio7" + id}>
          <input type="radio" className="btn-check" defaultChecked={selectedOption === 'SICK'} name="cold_start_status" onClick={(e) => this.handleRadioChange(e)} value="SICK" id={"btnradio7" + id} autoComplete="off" />S
        </label>
        <label className="btn btn-outline-primary mt-0" title="FINISHED" htmlFor={"btnradio9" + id}>
          <input type="radio" className="btn-check" defaultChecked={selectedOption === 'FINISHED'} name="cold_start_status" onClick={(e) => this.handleRadioChange(e)} value="FINISHED" id={"btnradio9" + id} autoComplete="off" />FN
        </label>
        <label className="btn btn-outline-secondary mt-0" title="Reset" htmlFor={"btnradio8" + id}>
          <input type="radio" className="btn-check" name="cold_start_status" onClick={(e) => this.handleRadioChange(e)} value="" id={"btnradio8" + id} autoComplete="off" /> Reset
        </label>
      </div>
    )
  }

}